(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

    const refreshCustomPicker = (picker) => {
      if (!picker) return;

      picker
        .querySelectorAll('.custom-choice-option, .custom-color-option')
        .forEach((option) => {
          const checkedInput = option.querySelector('input[type="radio"]:checked');
          const selectedText = option.querySelector('[data-custom-selected]');

          if (checkedInput && selectedText) {
            selectedText.textContent = checkedInput.value;
          }

          option.querySelectorAll('[data-custom-card]').forEach((card) => {
            const input = card.querySelector('input[type="radio"]');
            if (!input) return;

            const available = input.dataset.optionAvailable !== 'false';
            card.classList.toggle('is-selected', input.checked);
            card.classList.toggle('is-sold-out', !available);
          });

          option.querySelectorAll('[data-custom-button]').forEach((button) => {
            const input = button.querySelector('input[type="radio"]');
            if (!input) return;

            const available = input.dataset.optionAvailable !== 'false';
            button.classList.toggle('is-selected', input.checked);
            button.classList.toggle('is-sold-out', !available);
          });

          option.querySelectorAll('[data-custom-swatch]').forEach((swatch) => {
            const input = swatch.querySelector('input[type="radio"]');
            if (!input) return;

            const available = input.dataset.optionAvailable !== 'false';
            swatch.classList.toggle('is-selected', input.checked);
            swatch.classList.toggle('is-sold-out', !available);
          });
        });
    };

    const getJQuery = () => window.jQuery || window.$;

    const destroyChoiceSlider = (slider) => {
      const $ = getJQuery();
      if (!$ || !$.fn || !$.fn.slick) return;

      const $slider = $(slider);
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    };

    const initializeChoiceSlider = (slider) => {
      const $ = getJQuery();
      if (!$ || !$.fn || !$.fn.slick) return;

      const $slider = $(slider);
      const cardCount = slider.querySelectorAll(':scope > .custom-choice-card').length;

      if (!MOBILE_QUERY.matches) {
        destroyChoiceSlider(slider);
        return;
      }

      if (cardCount <= 1 || $slider.hasClass('slick-initialized')) return;

      $slider.slick({
        slidesToShow: 2.5,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: false,
        swipe: true,
        touchMove: true,
        draggable: true,
        adaptiveHeight: false,
        speed: 350,
        cssEase: 'ease',
        variableWidth: false,
        accessibility: true
      });
    };

    const refreshChoiceSliders = (scope = document) => {
      scope.querySelectorAll('[data-choice-slider]').forEach((slider) => {
        initializeChoiceSlider(slider);
      });
    };

    const initializeCustomPicker = (scope = document) => {
      const pickers = scope.querySelectorAll('variant-picker');

      pickers.forEach((picker) => {
        refreshCustomPicker(picker);
        refreshChoiceSliders(picker);

        if (picker.dataset.customPickerInitialized === 'true') return;
        picker.dataset.customPickerInitialized = 'true';

        picker.addEventListener('change', () => {
          window.requestAnimationFrame(() => {
            refreshCustomPicker(picker);

            const $ = getJQuery();
            if ($ && $.fn && $.fn.slick) {
              picker.querySelectorAll('[data-choice-slider].slick-initialized').forEach((slider) => {
                $(slider).slick('setPosition');
              });
            }
          });
        });
      });
    };

    const initializeAll = (scope = document) => {
      initializeCustomPicker(scope);
      refreshChoiceSliders(scope);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => initializeAll(), 120);
    });

    if (MOBILE_QUERY.addEventListener) {
      MOBILE_QUERY.addEventListener('change', () => initializeAll());
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:block:select', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:reorder', () => initializeAll());
  })();
  } catch(e) { console.error(e); }
})();

})();
